import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import BannerContent from './_internal/BannerContent';
import { HEADING_PROP_TYPES } from '../constants/componentPropTypes';

const BORDER_BANNER_CONTENT_CONTAINER_CLASSES =
    'eds-g-cell eds-g-cell-sm-12-12 eds-g-sw-cell-9-12';
const BORDER_BANNER_CONTAINER_CLASSES =
    'eds-g-grid eds-bg-color--ui-orange eds-l-pad-all-1 ';
const BORDER_BANNER_CLASSES =
    'eds-g-group eds-bg-color--white eds-l-pad-all-16 eds-l-sn-pad-all-10 eds-l-sm-pad-all-10 eds-align--center-vertical';

export default class BorderBanner extends PureComponent {
    static propTypes = {
        ...HEADING_PROP_TYPES,
        /*
        The type of illustration to show
        */
        illustration: PropTypes.string,
        /*
        CTA for button
        */
        CTA: translationPropType,
        /*
        CTA style for button
        */
        CTAStyle: PropTypes.string,
        /*
        Action to trigger when CT is clicked
        */
        onClick: PropTypes.func,
    };

    render() {
        const {
            CTA,
            CTAStyle,
            description,
            heading,
            secondaryHeading,
            onClick,
        } = this.props;

        const borderBannerContent = (
            <div className={BORDER_BANNER_CONTENT_CONTAINER_CLASSES}>
                <BannerContent
                    CTA={CTA}
                    CTAStyle={CTAStyle}
                    onClick={onClick}
                    alignCTAButtonRight={true}
                    heading={heading}
                    secondaryHeading={secondaryHeading}
                    description={description}
                />
            </div>
        );

        return (
            <div className={BORDER_BANNER_CONTAINER_CLASSES}>
                <div className={BORDER_BANNER_CLASSES}>
                    {borderBannerContent}
                </div>
            </div>
        );
    }
}
